// import { get } from 'lodash'

export default function () {
  const professionalParams = window.location.href.toString().split('/')
  this.cnpj = professionalParams[3]
  this.crm = professionalParams[4]
  this.uf = professionalParams[5]

  if (!this.crm && !this.uf) {
  }

  this.checkDomainOperator()
}



// WEBPACK FOOTER //
// ./src/app/patient/profile-company-professional/gadget/resources/mounted.js